import { render, staticRenderFns } from "./RefPage.vue?vue&type=template&id=1fd3b628&"
import script from "./RefPage.vue?vue&type=script&lang=js&"
export * from "./RefPage.vue?vue&type=script&lang=js&"
import style0 from "./RefPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RefPage.vue"
export default component.exports